import {Stack, Typography} from '@mui/material'


export function NotFound() {
  return <Stack gap={2} justifyContent="center" alignItems="center" width="100vw" height="100vh">
    <img src="/goschool-ai.svg" alt="GoSchool.AI" height={200}/>

    <Typography variant="h2">Not Found</Typography>
  </Stack>
}


